// FiscalCOTabXL - Sprint 44 Fase 3 Vista 2.
// Campos fiscales Colombia. Visibles solo si pais == Colombia.
// [FIX bug heredado] Banner actualizado: FE DIAN ya existe (S35, stub sandbox).
// Texto legacy decia "fase futura" lo cual era falso post-S35.
import { useEffect } from 'react';
import { ensureKeyframes, injectCSS } from '../../../design/motion';
import XLInput from '../../../components/xl/XLInput';
import XLSelect from '../../../components/xl/XLSelect';
import {
  TIPO_DOCUMENTO_CO, TIPO_ORGANIZACION_CO, REGIMEN_FISCAL_CO, esColombia,
} from '../../clientes/form/utils';

const CSS_ID = 'xl-cli-fiscal-co-css';
const CSS = `
.xl-cli-fco {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.xl-cli-fco__note {
  background: rgba(217,119,6,0.08);
  border: 1px solid rgba(217,119,6,0.25);
  color: var(--xl-color-warning);
  border-radius: var(--xl-radius-md);
  padding: 10px 12px;
  font-size: 13px;
  line-height: 1.45;
  font-family: var(--xl-font-sans);
}
[data-xl-theme="dark"] .xl-cli-fco__note {
  background: rgba(245,158,11,0.14);
  border-color: rgba(245,158,11,0.35);
}
.xl-cli-fco__off {
  padding: 16px;
  color: var(--xl-color-text-muted);
  font-size: 13px;
  font-family: var(--xl-font-sans);
}
.xl-form-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
}
@media (max-width: 720px) { .xl-form-grid { grid-template-columns: 1fr } }
`;

const DOC_OPTIONS = [
  { value: '', label: 'Selecciona tipo...' },
  ...TIPO_DOCUMENTO_CO,
];
const ORG_OPTIONS = [
  { value: '', label: 'Selecciona tipo...' },
  ...TIPO_ORGANIZACION_CO,
];
const REG_OPTIONS = [
  { value: '', label: 'Selecciona regimen...' },
  ...REGIMEN_FISCAL_CO,
];

export default function FiscalCOTabXL({ form, set }) {
  useEffect(() => {
    ensureKeyframes();
    injectCSS(CSS_ID, CSS);
  }, []);

  if (!esColombia(form.pais)) {
    return (
      <div className="xl-cli-fco__off" role="note">
        Este tab solo aplica cuando el pais es Colombia.
      </div>
    );
  }

  return (
    <div className="xl-cli-fco">
      <div className="xl-cli-fco__note" role="note">
        Datos fiscales para factura electronica DIAN. La FE actual opera en
        modalidad sandbox (Sprint 35) y utiliza estos campos al generar
        XML UBL y PDF representacion grafica.
      </div>

      <div className="xl-form-grid">
        <XLSelect
          label="Tipo de documento"
          value={form.tipo_documento || ''}
          onChange={(e) => set('tipo_documento', e.target.value)}
          options={DOC_OPTIONS}
        />
        <XLInput
          label="NIT / Numero de documento"
          value={form.nit || ''}
          onChange={(e) => set('nit', e.target.value)}
          placeholder="900123456"
        />
        <XLInput
          label="Digito verificacion (DV)"
          value={form.dv || ''}
          onChange={(e) => set('dv', e.target.value)}
          placeholder="7"
        />
        <XLSelect
          label="Tipo de organizacion"
          value={form.tipo_organizacion || ''}
          onChange={(e) => set('tipo_organizacion', e.target.value)}
          options={ORG_OPTIONS}
        />
        <XLSelect
          label="Regimen fiscal"
          value={form.regimen_fiscal || ''}
          onChange={(e) => set('regimen_fiscal', e.target.value)}
          options={REG_OPTIONS}
        />
        <XLInput
          label="Responsabilidad fiscal (codigo)"
          hint="O-13, O-15, R-99-PN, etc."
          value={form.responsabilidad_fiscal || ''}
          onChange={(e) => set('responsabilidad_fiscal', e.target.value)}
          placeholder="R-99-PN"
        />
        <XLInput
          label="Codigo DANE municipio"
          value={form.codigo_dane_municipio || ''}
          onChange={(e) => set('codigo_dane_municipio', e.target.value)}
          placeholder="05001"
        />
        <XLInput
          label="Codigo DANE departamento"
          value={form.codigo_dane_departamento || ''}
          onChange={(e) => set('codigo_dane_departamento', e.target.value)}
          placeholder="05"
        />
        <XLInput
          label="Codigo postal"
          value={form.codigo_postal || ''}
          onChange={(e) => set('codigo_postal', e.target.value)}
          placeholder="050010"
        />
      </div>
    </div>
  );
}
